var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomBlock5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 200,
    viewBox: "0 0 400 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 200,
    fill: "#F6F6FB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2013_2320)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 112,
    transform: "translate(0 44)",
    fill: "#B5C3E5"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 44,
    width: 400,
    height: 112,
    fill: "#F6F6FB"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -152.735,
    y1: 49.6568,
    x2: 164.049,
    y2: -267.127,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -145.664,
    y1: 56.7279,
    x2: 171.12,
    y2: -260.056,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -138.593,
    y1: 63.7989,
    x2: 178.191,
    y2: -252.985,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -131.522,
    y1: 70.87,
    x2: 185.262,
    y2: -245.914,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -124.451,
    y1: 77.9411,
    x2: 192.333,
    y2: -238.843,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -117.38,
    y1: 85.0122,
    x2: 199.404,
    y2: -231.772,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -110.309,
    y1: 92.0832,
    x2: 206.475,
    y2: -224.701,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -103.238,
    y1: 99.1544,
    x2: 213.546,
    y2: -217.629,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -96.1664,
    y1: 106.225,
    x2: 220.617,
    y2: -210.558,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -89.0954,
    y1: 113.296,
    x2: 227.688,
    y2: -203.487,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -82.0243,
    y1: 120.368,
    x2: 234.76,
    y2: -196.416,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -74.9533,
    y1: 127.439,
    x2: 241.831,
    y2: -189.345,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -67.8822,
    y1: 134.51,
    x2: 248.902,
    y2: -182.274,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -60.8112,
    y1: 141.581,
    x2: 255.973,
    y2: -175.203,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -53.7401,
    y1: 148.652,
    x2: 263.044,
    y2: -168.132,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -46.6691,
    y1: 155.723,
    x2: 270.115,
    y2: -161.061,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -39.5981,
    y1: 162.794,
    x2: 277.186,
    y2: -153.99,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -32.527,
    y1: 169.865,
    x2: 284.257,
    y2: -146.919,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -25.456,
    y1: 176.936,
    x2: 291.328,
    y2: -139.848,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -18.3847,
    y1: 184.007,
    x2: 298.399,
    y2: -132.777,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -11.3136,
    y1: 191.078,
    x2: 305.47,
    y2: -125.706,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.24258,
    y1: 198.149,
    x2: 312.541,
    y2: -118.635,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.82846,
    y1: 205.22,
    x2: 319.612,
    y2: -111.564,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.89951,
    y1: 212.291,
    x2: 326.683,
    y2: -104.493,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.9706,
    y1: 219.362,
    x2: 333.754,
    y2: -97.4215,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.0416,
    y1: 226.434,
    x2: 340.825,
    y2: -90.3503,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.1126,
    y1: 233.505,
    x2: 347.897,
    y2: -83.2793,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.1837,
    y1: 240.576,
    x2: 354.968,
    y2: -76.2082,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.2547,
    y1: 247.647,
    x2: 362.039,
    y2: -69.137,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.326,
    y1: 254.718,
    x2: 369.11,
    y2: -62.066,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59.3971,
    y1: 261.789,
    x2: 376.181,
    y2: -54.9949,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.4681,
    y1: 268.86,
    x2: 383.252,
    y2: -47.9239,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.5392,
    y1: 275.931,
    x2: 390.323,
    y2: -40.8529,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.6102,
    y1: 283.002,
    x2: 397.394,
    y2: -33.7818,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.6812,
    y1: 290.073,
    x2: 404.465,
    y2: -26.7108,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.7523,
    y1: 297.144,
    x2: 411.536,
    y2: -19.6397,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101.823,
    y1: 304.215,
    x2: 418.607,
    y2: -12.5686,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.894,
    y1: 311.286,
    x2: 425.678,
    y2: -5.49751,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 115.965,
    y1: 318.357,
    x2: 432.749,
    y2: 1.57353,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.036,
    y1: 325.429,
    x2: 439.82,
    y2: 8.6447,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.108,
    y1: 332.5,
    x2: 446.892,
    y2: 15.7157,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 137.179,
    y1: 339.571,
    x2: 453.963,
    y2: 22.7868,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.25,
    y1: 346.642,
    x2: 461.034,
    y2: 29.8578,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.321,
    y1: 353.713,
    x2: 468.105,
    y2: 36.9289,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158.392,
    y1: 360.784,
    x2: 475.176,
    y2: 43.9999,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165.463,
    y1: 367.855,
    x2: 482.247,
    y2: 51.071,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 172.534,
    y1: 374.926,
    x2: 489.318,
    y2: 58.142,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 179.605,
    y1: 381.997,
    x2: 496.389,
    y2: 65.2132,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.676,
    y1: 389.068,
    x2: 503.46,
    y2: 72.2842,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 193.747,
    y1: 396.139,
    x2: 510.531,
    y2: 79.3554,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200.818,
    y1: 403.21,
    x2: 517.602,
    y2: 86.4264,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 207.889,
    y1: 410.281,
    x2: 524.673,
    y2: 93.4975,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 214.961,
    y1: 417.352,
    x2: 531.744,
    y2: 100.569,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 222.032,
    y1: 424.423,
    x2: 538.815,
    y2: 107.64,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.103,
    y1: 431.494,
    x2: 545.886,
    y2: 114.711,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 236.174,
    y1: 438.566,
    x2: 552.958,
    y2: 121.782,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 243.245,
    y1: 445.637,
    x2: 560.029,
    y2: 128.853,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 250.316,
    y1: 452.708,
    x2: 567.1,
    y2: 135.924,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 257.387,
    y1: 459.779,
    x2: 574.171,
    y2: 142.995,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 264.458,
    y1: 466.85,
    x2: 581.242,
    y2: 150.066,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 271.529,
    y1: 473.921,
    x2: 588.313,
    y2: 157.137,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.348 112.39C113.574 112.39 111.919 112.097 110.382 111.513C108.868 110.907 107.537 110.063 106.39 108.982C105.243 107.9 104.345 106.634 103.696 105.184C103.069 103.713 102.755 102.122 102.755 100.413C102.755 98.6818 103.069 97.0914 103.696 95.6416C104.345 94.1919 105.232 92.9369 106.358 91.8766C107.504 90.8163 108.835 89.9941 110.35 89.4099C111.865 88.804 113.509 88.5011 115.283 88.5011C117.079 88.5011 118.724 88.7824 120.217 89.345C121.71 89.9075 123.008 90.6865 124.112 91.6819L119.795 96.0311C119.276 95.4685 118.637 95.025 117.88 94.7004C117.144 94.3758 116.279 94.2135 115.283 94.2135C114.418 94.2135 113.617 94.3542 112.882 94.6355C112.167 94.9168 111.551 95.3279 111.031 95.8688C110.512 96.4098 110.101 97.0698 109.798 97.8487C109.517 98.6061 109.376 99.4608 109.376 100.413C109.376 101.387 109.517 102.263 109.798 103.042C110.101 103.799 110.512 104.448 111.031 104.989C111.551 105.53 112.167 105.952 112.882 106.255C113.617 106.536 114.418 106.677 115.283 106.677C116.257 106.677 117.123 106.526 117.88 106.223C118.659 105.92 119.33 105.476 119.892 104.892L124.242 109.241C123.095 110.237 121.807 111.016 120.379 111.578C118.951 112.119 117.274 112.39 115.348 112.39Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.494 112.39C135.46 112.39 133.686 111.978 132.171 111.156C130.657 110.312 129.477 109.155 128.633 107.683C127.789 106.212 127.368 104.524 127.368 102.62V88.8906H133.859V103.204C133.859 103.94 134.021 104.567 134.346 105.087C134.67 105.606 135.103 106.006 135.644 106.288C136.207 106.547 136.823 106.677 137.494 106.677C138.187 106.677 138.792 106.547 139.312 106.288C139.853 106.006 140.275 105.617 140.578 105.119C140.881 104.6 141.032 103.972 141.032 103.237V88.8906H147.556V102.652C147.556 104.557 147.134 106.244 146.29 107.716C145.468 109.165 144.299 110.312 142.785 111.156C141.292 111.978 139.528 112.39 137.494 112.39Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.469 112.39C157.5 112.39 155.78 112.108 154.309 111.546C152.859 110.961 151.517 110.042 150.284 108.787L154.341 104.73C155.185 105.53 156.072 106.147 157.003 106.58C157.933 106.991 158.928 107.196 159.989 107.196C160.876 107.196 161.547 107.067 162.001 106.807C162.455 106.526 162.683 106.147 162.683 105.671C162.683 105.195 162.488 104.805 162.098 104.502C161.709 104.178 161.19 103.897 160.541 103.659C159.913 103.399 159.21 103.139 158.431 102.88C157.673 102.62 156.916 102.306 156.159 101.938C155.401 101.57 154.698 101.127 154.049 100.608C153.422 100.067 152.913 99.4067 152.524 98.6277C152.134 97.8271 151.939 96.8534 151.939 95.7066C151.939 94.2135 152.296 92.9261 153.01 91.8442C153.725 90.7623 154.731 89.94 156.029 89.3774C157.327 88.7932 158.853 88.5011 160.605 88.5011C162.336 88.5011 163.938 88.7824 165.409 89.345C166.902 89.8859 168.135 90.6649 169.109 91.6819L165.02 95.739C164.306 95.0466 163.591 94.5381 162.877 94.2135C162.163 93.8673 161.384 93.6942 160.541 93.6942C159.87 93.6942 159.329 93.8024 158.918 94.0188C158.528 94.2352 158.333 94.5597 158.333 94.9925C158.333 95.4469 158.528 95.8256 158.918 96.1285C159.307 96.4098 159.816 96.6695 160.443 96.9075C161.092 97.1455 161.796 97.3943 162.553 97.654C163.332 97.9136 164.1 98.2274 164.857 98.5952C165.615 98.9415 166.307 99.3959 166.935 99.9584C167.584 100.499 168.103 101.181 168.493 102.003C168.882 102.825 169.077 103.821 169.077 104.989C169.077 107.348 168.233 109.176 166.545 110.475C164.879 111.751 162.52 112.39 159.469 112.39Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.87 112V88.8906H184.361V112H177.87ZM170.956 94.4083V88.8906H191.307V94.4083H170.956Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.551 112.454C203.734 112.454 202.057 112.152 200.52 111.546C199.006 110.94 197.675 110.096 196.528 109.014C195.403 107.932 194.527 106.655 193.899 105.184C193.272 103.713 192.958 102.122 192.958 100.413C192.958 98.6818 193.261 97.0914 193.867 95.6416C194.494 94.1919 195.37 92.9261 196.496 91.8442C197.621 90.7623 198.941 89.9292 200.455 89.345C201.992 88.7391 203.669 88.4362 205.486 88.4362C207.304 88.4362 208.97 88.7391 210.485 89.345C212.021 89.9292 213.352 90.7623 214.477 91.8442C215.602 92.9261 216.468 94.2027 217.074 95.6741C217.701 97.1239 218.015 98.7143 218.015 100.445C218.015 102.155 217.701 103.745 217.074 105.216C216.468 106.666 215.602 107.943 214.477 109.046C213.352 110.128 212.032 110.972 210.517 111.578C209.002 112.162 207.347 112.454 205.551 112.454ZM205.486 106.742C206.698 106.742 207.747 106.482 208.635 105.963C209.522 105.444 210.203 104.708 210.679 103.756C211.155 102.804 211.394 101.689 211.394 100.413C211.394 99.4608 211.253 98.6061 210.972 97.8487C210.712 97.0698 210.322 96.4098 209.803 95.8688C209.284 95.3063 208.656 94.8843 207.921 94.603C207.207 94.3001 206.395 94.1486 205.486 94.1486C204.275 94.1486 203.225 94.4083 202.338 94.9276C201.451 95.4253 200.769 96.1501 200.293 97.1022C199.817 98.0327 199.579 99.1362 199.579 100.413C199.579 101.387 199.709 102.263 199.969 103.042C200.25 103.821 200.65 104.492 201.17 105.054C201.689 105.595 202.306 106.017 203.02 106.32C203.755 106.601 204.578 106.742 205.486 106.742Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.986 112V88.8906H226.692L235.294 101.484H233.249L241.818 88.8906H246.524V112H240.097V99.5365L241.039 99.7962L236.332 106.547H232.178L227.504 99.7962L228.413 99.5365V112H221.986Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.125 112L271.149 88.8906H276.213L272.156 112H267.125ZM257.745 105.736V101.516H277.024V105.736H257.745ZM259.497 112L263.554 88.8906H268.553L264.561 112H259.497ZM258.913 98.8874V94.7004H278.16V98.8874H258.913Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.761 112.39C287.182 112.39 285.634 112.119 284.12 111.578C282.627 111.016 281.393 110.226 280.42 109.209L284.509 105.216C284.877 105.736 285.429 106.169 286.165 106.515C286.922 106.839 287.701 107.002 288.502 107.002C289.194 107.002 289.789 106.883 290.287 106.645C290.784 106.407 291.174 106.071 291.455 105.638C291.736 105.184 291.877 104.665 291.877 104.08C291.877 103.496 291.726 102.977 291.423 102.523C291.141 102.047 290.719 101.679 290.157 101.419C289.594 101.138 288.902 100.997 288.08 100.997C287.387 100.997 286.738 101.105 286.132 101.322C285.526 101.538 285.007 101.808 284.574 102.133L285.288 97.9786C285.937 97.654 286.489 97.3835 286.944 97.1671C287.398 96.9507 287.863 96.7993 288.339 96.7127C288.815 96.6045 289.378 96.5504 290.027 96.5504C291.823 96.5504 293.327 96.9075 294.539 97.6215C295.75 98.3356 296.67 99.2877 297.297 100.478C297.925 101.646 298.239 102.923 298.239 104.308C298.239 105.887 297.849 107.294 297.07 108.527C296.313 109.739 295.231 110.691 293.825 111.383C292.418 112.054 290.73 112.39 288.761 112.39ZM284.574 102.133L282.205 100.056L283.406 88.8906H289.183L287.982 99.4391L284.574 102.133ZM284.12 94.2135L283.406 88.8906H296.973V94.2135H284.12Z",
    fill: "#2C314F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2013_2320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 112,
    fill: "white",
    transform: "translate(0 44)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomBlock5);
export default __webpack_public_path__ + "static/media/custom-block-5.a648733f4af18c8dd7c332576b4b3471.svg";
export { ForwardRef as ReactComponent };